import classnames from 'classnames'
import classNames from 'classnames'
import { Component } from 'react'

import { TIMEFRAME } from '../../main/constants'
import TilesStore from '../futures/stores/tilesStore'
import { FuturesTimeframe } from '../futures/types'
import { decodeQueryString, encodeQueryString } from '../queryString'
import CryptoActionCreators from './actions/cryptoActionCreators'
import ChartMenu from './components/ChartMenu'
import MenuNew from './components/redesign/Menu'
import Menu from './menu'
import { PageType } from './types'

interface ChartsState {
  timeframe: TIMEFRAME
  dateRange: string
  ticker: string
  type: string
  isGroupOpen: boolean
  activeGroup: string
}

function getChartsState(override: Partial<ChartsState> = {}) {
  var queryString = decodeQueryString()
  var timeframe = queryString['p'] as TIMEFRAME
  if (!Object.values(TIMEFRAME).includes(timeframe)) {
    timeframe = TIMEFRAME.d
  }
  var ticker = (queryString['t'] || 'ALL').toUpperCase()
  var type = queryString['ty']

  return {
    timeframe,
    dateRange: queryString['r'],
    ticker,
    type,
    ...override,
  }
}

class CryptoCharts extends Component {
  state = getChartsState()

  _onTimeframeChange = async (timeframe: TIMEFRAME) => {
    CryptoActionCreators.changeTimeframe(timeframe)
    this.setState(getChartsState({ timeframe }))
  }

  render() {
    const { timeframe, ticker, type, dateRange } = this.state
    const isDetailOpen = ticker !== 'ALL'

    var timeframes = {
      link: (key: string) => `/crypto_charts.ashx?${encodeQueryString({ t: ticker, p: key, ty: type, r: dateRange })}`,
      onClick: () => {},
      active: timeframe,
      timeframes: [
        { key: FuturesTimeframe.Minute5, value: '5M' },
        { key: FuturesTimeframe.Hourly, value: 'H' },
        { key: FuturesTimeframe.Daily, value: 'D' },
        { key: FuturesTimeframe.Weekly, value: 'W' },
        { key: FuturesTimeframe.Monthly, value: 'M' },
      ],
    }
    const isRedesignEnabled = FinvizSettings.hasRedesignEnabled
    const MenuComponent = isRedesignEnabled ? MenuNew : Menu

    return (
      <div
        className={classnames('forex flex-col', {
          futures: !isRedesignEnabled,
          'pb-5': isDetailOpen && isRedesignEnabled,
        })}
      >
        <div
          className={classNames({
            'border-b border-gray-100 bg-white dark:border-gray-600 dark:bg-gray-800':
              isRedesignEnabled && ticker !== 'ALL',
          })}
        >
          <div
            className={classnames(
              'mx-auto',
              isRedesignEnabled && {
                'max-w-[79rem]': !isDetailOpen,
                'max-w-[81.5rem] px-5': isDetailOpen,
              }
            )}
          >
            <MenuComponent
              activePage={PageType.Charts}
              timeframes={timeframes}
              isDetailOpen={isDetailOpen}
              company={TilesStore.getTile(ticker)?.label}
              onTimeframeChange={this._onTimeframeChange}
              onDateRangeChange={(dateRange) => this.setState(getChartsState({ dateRange }))}
            />
          </div>
        </div>
        {isDetailOpen && (
          <ChartMenu
            isRedesignEnabled={isRedesignEnabled}
            activeTile={ticker}
            activeTimeframe={timeframe}
            activeRange={dateRange}
            type={type}
            showChartControls={!isRedesignEnabled}
          />
        )}
      </div>
    )
  }
}

export default CryptoCharts
